/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

/* Change in this component dependents on 'Tax Exempt No.' in file src/components/reusable/ej-view-sections/TransactionTotals.js
*/
const TaxExemptTitle = ({
  contactDetails,
}) => {
  const { RL_TaxExempt } = useSelector((state) => state);
  return (
    <>
      {(contactDetails?.[0]?.TaxCertificates?.[0]?.Number) && (
      <>
        <p>*** {RL_TaxExempt} ***</p>
        <br />
      </>
    )}

    </>
);
};

TaxExemptTitle.defaultProps = {
  contactDetails: [],
};

TaxExemptTitle.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
};

export default TaxExemptTitle;
